/* global ga, picturefill */

// Import everything from autoload
//import './autoload/_bootstrap.js'; import './autoload/_jquery.easing.js'

// import external dependencies
import 'picturefill';
import 'lazysizes/lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/bgset/ls.bgset';
// import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Splitting from 'splitting';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import barba from '@barba/core';

import { app } from './modules/app';
import { resets } from './modules/resets';
import { elementExistCheck } from './modules/element-exist-check';
import { setupEvents } from './modules/events';
import { setupTeam } from './modules/team';
import { setupCursor, setupCursorText } from './modules/cursor';
import { setupNavbar } from './modules/navbar';
import { splitInner } from './modules/splitting-setup';
import { setupLazySizes } from './modules/lazysizes';
import { setupChevronParallax } from './modules/parallax';
import { setupYoutube } from './modules/youtube';
import { setupObserver, setupObserverOnLoad } from './modules/observer-setup';
import { track_load as leadForensics } from './util/lead-forensics';
// import {setupInertiaScroll} from './modules/inertia-scroll';

// ----------------------------------------------------------------------------
//
// Initialise LazySizes just the once
//
// DON'T WAIT FOR DOC READY
// ----------------------------------------------------------------------------
setupLazySizes();

// Picturefill init
if ('function' === typeof picturefill) {
  // Prompt picturefill to init
  picturefill();
}

const barbaContainer = $('.barba-container');
const barbaCover = $('.barba-cover');

const setupOnReady = () => {
  console.log('{ setupOnReady }');
  // Reset vars
  resets();

  // Init events
  setupEvents();

  // ScrollMagic Controller init
  app.controller = new ScrollMagic.Controller();

  // Setup Splitting
  Splitting();
  splitInner($('.splitting .word'));

  // Observe Elements Enter/Exit Viewport
  setupObserver();

  // Check for team module
  setupTeam();

  // Setup YouTube
  setupYoutube();

  // Cursor
  if (barbaContainer.hasClass('desktop')) {
    // inject data-cursor attribute to anchors under CMS control
    setupCursorText();

    setupCursor();
  }
};

const setupOnLoad = () => {
  console.log('{ setupOnLoad }');
  // Element exist check
  elementExistCheck();

  // Setup NavBar
  setupNavbar();

  // Observe Elements Enter/Exit Viewport
  setupObserverOnLoad();

  if (barbaContainer.hasClass('desktop')) {
    // Chevron Parallax
    setupChevronParallax();
    // Setup Inertia Scrolling
    // setupInertiaScroll();
  }
};

// ----------------------------------------------------------------------------
//
// Doc Ready
//
// ----------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  setupOnReady();

  // Reveal content
  $('body').addClass('loaded');
});

// ----------------------------------------------------------------------------
//
// Window Load
//
// ----------------------------------------------------------------------------
window.addEventListener('load', () => {
  setupOnLoad();
});

// ----------------------------------------------------------------------------
//
// Barba
//
// ----------------------------------------------------------------------------
barba.init({
  // disable cache otherwise fade out/in effects don't get time to run
  // cacheIgnore: true,
  // debug
  // debug: true,
  // increase timeout
  timeout: 5000,
  // barba ignore these click events
  prevent: ({ el }) => {
    (el.classList && el.classList.contains('btn--submit')) ||
      el.classList.contains('js-team-close');
  },
  transitions: [
    {
      leave: () => {
        return new Promise((resolve) => {
          // hide cursor
          $('#cursor').addClass('hidden');
          // reverse all .show animation
          $('.show').removeClass('show');
          // pause to allow time for reverse animation
          setTimeout(() => {
            // show 'cover' div
            barbaCover.addClass('show');
            // resolve promise
            resolve();
          }, 500);
        });
      },
      beforeEnter: ({ current }) => {
        return new Promise((resolve) => {
          // scroll top
          $('html,body').scrollTop(0);
          // remove current content
          $(current.container).remove();
          // fade out content
          $('body').removeClass('loaded');
          // resolve promise
          resolve();
        });
      },
      afterEnter: () => {
        return new Promise((resolve) => {
          // onReady setup
          setupOnReady();
          // Reveal content
          $('body').addClass('loaded');
          // hide 'cover' div
          barbaCover.removeClass('show');
          // onLoad setup
          setupOnLoad();
          // resolve promise
          resolve();
        });
      },
      after: () => {
        return new Promise((resolve) => {
          if (window.ga) {
            // Google Analytics
            ga('set', 'page', window.location.pathname);
            ga('send', 'pageview');
          }
          // Lead Forensics
          leadForensics(window.location.href, window.location.pathname);
          // resolve promise
          resolve();
        });
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./scripts/main.js